#import "~/graphql/fragments/assets/defaultImageAsset.graphql"
#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment teamMemberPageContent on teamMembers_default_Entry {
    title
    textarea
    email: plainEmail
    phoneNumber: plaintext
    department: selectTeamDepartment {
        title
    }
    showLink: plainSwitch
    uri
    image {
        ... DefaultImageAsset
    }
    seo {
        ... socialFragment
    }
    flexibleSections {
        ... flexibleSections
    }
    showNewsletterSubscribe
}
